import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './titleWithIcon.module.scss';

export const TitleWithIcon = memo(({ iconImage, title }) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <img src={iconImage} alt="icon" className="icon" />
      </div>
      <div className={styles.text}>{title}</div>
    </div>
  );
});

TitleWithIcon.propTypes = {
  iconImage: PropTypes.string,
  title: PropTypes.string,
};

TitleWithIcon.defaultProps = {
  iconImage: '',
  title: '',
};
